import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=6d15ef50&scoped=true&"
import script from "./PluginList.vue?vue&type=script&lang=js&"
export * from "./PluginList.vue?vue&type=script&lang=js&"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=6d15ef50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15ef50",
  null
  
)

export default component.exports